import React from 'react'
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import $ from 'jquery'

import CreateEditMenuGroup from './CreateEditMenuGroup'

import { clearNoDataError } from '../../GlobalStateContainer/actions'

import {
    fetchLocationMenuGroupsList,
    fetchLocationMenuGroup,
    fetchMenuGroupErrorClear,
    fetchMenuGroupError,
    createMenuGroup,
    updateMenuGroup,
    errorMenuGroup
} from './actions'

import CommError from '../../Shared/Errors/Errors'
import ConfirmModal from '../../Shared/ConfirmModal/ConfirmModal'

import './LocationMenuGroups.css'

var Spinner = require('react-spinkit');

let chkReturn = 0;


class LocationMenuGroups extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMenuGroupMode: false,
            viewMode: false,
            nameSrch: '',
            menuGroup: {
                name: '',
                displayOrder: '0',
                locationGroupTypeId: '0',
                isActive: true
            },
        };

        this.fetchMenuGroupErrorClear = this.fetchMenuGroupErrorClear.bind(this);
        this.errorMenuGroupClear = this.errorMenuGroupClear.bind(this);
        this.errorNoDataClear = this.errorNoDataClear.bind(this);
        this.locationMenuGroupEdit = this.locationMenuGroupEdit.bind(this);
        this.locationMenuGroupEditVerify = this.locationMenuGroupEditVerify.bind(this);
        this.locationMenuGroupCreate = this.locationMenuGroupCreate.bind(this);
        this.search = this.search.bind(this);
        this.updateLocationMenuGroup = this.updateLocationMenuGroup.bind(this);
        this.cancelLocationMenuGroup = this.cancelLocationMenuGroup.bind(this);
        this.closeLocationMenuGroup = this.closeLocationMenuGroup.bind(this);
        this.menuGroupView = this.menuGroupView.bind(this);
        this.viewModeVerify = this.viewModeVerify.bind(this);
        this.menuGroupCheck = this.menuGroupCheck.bind(this);
        this.afterOpen = this.afterOpen.bind(this);
    }

    fetchMenuGroupErrorClear() {
        this.props.dispatch(fetchMenuGroupError);
    }

    errorNoDataClear() {
        this.props.dispatch(clearNoDataError);
    }

    afterOpen() {
        this.menuGroupCheck();
    }

    menuGroupCheck() {

        if ($('#location_menu_group_name').val().length === 0 || $('#location_menu_group_type').val() === "0" || this.state.viewMode === true)
            $('button.modbrick').attr("disabled", "disabled")
        else
            $('button.modbrick').removeAttr("disabled")
    }

    errorMenuGroupClear(e) {
        this.props.dispatch(errorMenuGroup);

        if (this.props.locationMenuGroup.error === "409") {
            let id = e.target.attributes.locationMenuGroup.id;

            fetchLocationMenuGroup.bind(this)(id, false);
        }
    }

    locationMenuGroupEdit(e) {
        if (chkReturn || this.props.locationMenuGroups.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.menuGroup.value;
        this.setState({
            menuGroup: {
                name: '',
                displayOrder: '0',
                locationGroupTypeId: '0',
                isActive: true
            }
        });

        fetchLocationMenuGroup.bind(this)(id, false);

        chkReturn = setInterval(this.locationMenuGroupEditVerify, 500);
    }
    locationMenuGroupEditVerify() {
        if (this.props.locationMenuGroup.updated || this.props.locationMenuGroup.error) {
            this.setState({
                value: -1,
                editMenuGroup: true,
                editMenuGroupMode: true
            });
        }

        clearInterval(chkReturn);
        chkReturn = 0;
    }
    locationMenuGroupCreate() {
        if (this.props.locationMenuGroups.fetching) return

        fetchLocationMenuGroup.bind(this)(0, true);

        let emptyMenuGroup = {
            name: '',
            locationGroupTypeId: '0',
            displayOrder: '0',
            isActive: true
        };

        this.setState({
            menuGroup: emptyMenuGroup,
            editMenuGroup: false,
            editMenuGroupMode: true
        });
    }

    search(e) {
        this.setState({ nameSrch: e.target.value.toLowerCase() })
    }

    menuGroupView(e) {
        if (chkReturn || this.props.locationMenuGroups.fetching) return;
        chkReturn = 1;

        let id = e.target.attributes.menuGroup.value;

        this.setState({
            menuGroup: {
                name: '',
                displayOrder: '0',
                locationGroupTypeId: '0',
                isActive: true
            }
        });

        fetchLocationMenuGroup.bind(this)(id, false);

        chkReturn = setInterval(this.viewModeVerify, 500);
    }

    viewModeVerify() {
        this.setState({
            value: -1,
            editMenuGroup: true,
            editMenuGroupMode: true,
            viewMode: true
        });

        clearInterval(chkReturn);
        chkReturn = 0;
    }

    updateLocationMenuGroup(e) {
        $('button.modbrick').attr('disabled', 'disabled')

        let create = e.target.attributes.create.value;
        let menuGroup = {
            name: $('#location_menu_group_name').val().trim(),
            displayOrder: $('#location_menu_display_order').val(),
            locationGroupTypeId: $('#location_menu_group_type').val(),
            isActive: $('#location_menu_group_status').val()
        };

        if (create === 'true') {
            createMenuGroup.bind(this)(menuGroup);
        }
        else {
            menuGroup.LocationMenuGroupId = parseInt($('#location_menu_group_id').text());
            updateMenuGroup.bind(this)(menuGroup.LocationMenuGroupId, menuGroup);
        }

        chkReturn = setInterval(this.closeLocationMenuGroup, 100);
    }
    cancelLocationMenuGroup() {
        this.props.dispatch(errorMenuGroup);

        this.setState({
            editMenuGroupMode: false,
            viewMode: false 
        });

        this.props.dispatch(fetchLocationMenuGroupsList);
    }
    closeLocationMenuGroup() {
        if (this.props.locationMenuGroup.updated || this.props.locationMenuGroup.error) {
            $('button.modbrick').removeAttr('disabled')

            if (this.props.locationMenuGroup.updated) {
                this.cancelLocationMenuGroup();
            }

            clearInterval(chkReturn);
            chkReturn = 0;
        }
    }


    render() {
        return (
            <div className="location-menu-groups col-xs-12">
                <CommError error={this.props.locationMenuGroup.error} onClose={this.errorMenuGroupClear} />
                <CommError error={this.props.locationMenuGroups.error} onClose={this.fetchMenuGroupErrorClear} />

                <ConfirmModal open={this.props.locationMenuGroups.noData} heading={"Location Menu Groups"} msg={"No Records"} notifyOnly={true} onYes={this.errorNoDataClear} />

                <div className="headWrapper">
                    <div className="locationMenuGroups ">
                        <h1>Location Menu Groups</h1>
                    </div>
                    <div className="button">
                        <button onClick={this.locationMenuGroupCreate}
                            className="btn btn-primary pull-right"
                        > + Create Location Group </button>
                    </div>
                </div>

                <div id="srch">
                    <span>Search by Name:</span>
                    {
                        this.props.locationMenuGroups.fetching ?
                            <input id="name" autocomplete="off" spellcheck="false" disabled />
                        :
                            <input id="name" autocomplete="off" spellcheck="false" onChange={this.search} />
                    }
                </div>

                <div className="tableWrapper"> 
                    {
                        this.props.locationMenuGroups.fetching ?
                            <Spinner name='line-spin-fade-loader' />
                        :
                            null
                    }
                    <table className="lists table table-striped">
                        <thead>
                            <tr className="head">
                                <th>Group Name</th>
                                <th>Display Order</th>
                                <th>Group Type</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.props.locationMenuGroups ?
                                    this.props.locationMenuGroupsList.filter((group) => {
                                        if (this.state.nameSrch.length) {
                                            if (group.name.toLowerCase().startsWith(this.state.nameSrch)) {
                                                group.prefix = group.name.substring(0, this.state.nameSrch.length)
                                                group.suffix = group.name.substring(this.state.nameSrch.length)

                                                return true
                                            }
                                            else return false
                                        }
                                        else return true
                                    }).map((group, index) => {
                                        if (group.isActive.toString() === "false") {
                                            return <tr className="body" key={index}>
                                                <td className="name" menuGroup={group.id} onClick={this.menuGroupView}>
                                                    {this.state.nameSrch.length ? <p><span className="srch">{group.prefix}</span><span>{group.suffix}</span></p> : group.name}
                                                </td>
                                                <td>{group.displayOrder}</td>
                                                <td>{group.locationGroupTypeName}</td>
                                                <td>inactive</td>
                                                <td>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                        <i className="fa fa-edit" menuGroup={group.id} onClick={this.locationMenuGroupEdit}></i>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        }
                                        else {
                                            return <tr id="locationRow" className="body" key={index}>
                                                <td className="name" menuGroup={group.id} onClick={this.menuGroupView}>
                                                   {this.state.nameSrch.length ? <p><span className="srch">{group.prefix}</span><span>{group.suffix}</span></p> : group.name}
                                                </td>
                                                <td>{group.displayOrder}</td>
                                                <td>{group.locationGroupTypeName}</td>
                                                <td>active</td>
                                                <td>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit</Tooltip>}>
                                                        <i className="fa fa-edit" menuGroup={group.id} onClick={this.locationMenuGroupEdit}></i>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>  
                                        }
                                    })
                                : null
                            }
                        </tbody>
                    </table>
                </div>
               
                <CreateEditMenuGroup
                    errMenuGroup={this.props.locationMenuGroup}
                    errMenuGroupClear={this.errorMenuGroupClear}
                    curLocationMenuGroup={this.props.locationMenuGroup.menuGroup}
                    locationMenuGroupTypes={this.props.locationMenuGroup}
                    tmpLocationMenuGroup={this.state.menuGroup}
                    viewMode={this.state.viewMode}
                    create={this.state.editMenuGroup}
                    isOpen={this.state.editMenuGroupMode}
                    valuesCheck={this.menuGroupCheck}
                    onAfterOpen={this.afterOpen}
                    onRequestClose={this.updateLocationMenuGroup}
                    onRequestCancel={this.cancelLocationMenuGroup}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    locationMenuGroup: state.locationMenuGroup,
    locationMenuGroups: state.locationMenuGroups
});

export default connect(mapStateToProps)(LocationMenuGroups)